module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-500.071156e.ttf";